import PartnerCategoriesAdd from "./PartnerCategoriesAdd";

export default PartnerCategoriesAdd;
